import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarSeparator,
  useSidebar,
} from "@replo/design-system/components/sidebar/Sidebar";
import twMerge from "@replo/design-system/utils/twMerge";
import useHasFailedPayment from "@v2/features/billing/hooks/useHasFailedPayment";
import PaymentFailedSidebarPanel from "@v2/features/billing/PaymentFailedSidebarPanel";
import DashboardSidebarNav from "@v2/features/dashboard/sidebar/dashboard-sidebar-nav/DashboardSidebarNav";
import { NavUser } from "@v2/features/dashboard/sidebar/NavUser";
import { ProjectSelector } from "@v2/features/dashboard/sidebar/project-selector/ProjectSelector";
import { ReferralPanel } from "@v2/features/dub/ReferralPanel";
import { ChevronsLeft, ChevronsRight } from "lucide-react";

export default function DashboardSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { open, toggleSidebar, isMobile } = useSidebar();
  const hasFailedPayment = useHasFailedPayment();

  return (
    <Sidebar variant="floating" collapsible="icon" {...props}>
      <SidebarHeader UNSAFE_className="pb-0 gap-0!">
        <ProjectSelector />

        <SidebarSeparator />

        {!isMobile && (
          <Button
            icon
            size="sm"
            variant="secondary"
            onClick={toggleSidebar}
            UNSAFE_className={twMerge(
              "absolute top-[73px] right-0",
              !open && "top-[57px]",
            )}
          >
            {open ? <ChevronsLeft /> : <ChevronsRight />}
          </Button>
        )}
      </SidebarHeader>

      <SidebarContent UNSAFE_className="pt-2">
        <DashboardSidebarNav />
        <div className="px-3 mt-auto">
          {hasFailedPayment ? <PaymentFailedSidebarPanel /> : <ReferralPanel />}
        </div>
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
